/** @ngInject */
export default function EndpointsController($stateParams, NotificationService, UtilService, endpointsService) {
  const vm = this;
  vm.isLoading = false;
  vm.endpoints = [];
  vm.notificationSystemId = $stateParams.notificationSystemId;
  vm.methods = ['GET', 'POST'];

  vm.init = init;
  vm.update = update;
  vm.remove = remove;

  init();

  function init() {
    getAvailableNotificationTypes();
    getEndpoints();
  }

  function getEndpoints() {
    vm.endpoints = [];
    endpointsService
      .getEndpoints(vm.notificationSystemId)
      .then(res => vm.endpoints = res.data.webHookEndpoints);
  }

  function getAvailableNotificationTypes() {
    endpointsService
      .getAvailableNotificationTypes()
      .then(res => vm.notificationTypes = res.data)
  }

  function update(endpoint) {
    vm.isLoading = true;
    endpointsService
      .update(vm.notificationSystemId, endpoint)
      .then(() => {
        NotificationService.success('Endpoint updated');
      })
      .catch((res) => {
        NotificationService.error(res.data.errors[0].message)
      })
      .finally(() => {
        vm.isLoading = false;
      })
  }

  function remove(endpoint) {
    vm.isLoading = true;
    endpointsService
      .remove(vm.notificationSystemId, endpoint.id)
      .then(() => {
        NotificationService.success('Endpoint deleted');
        UtilService.toggleElementFromArray(vm.endpoints, endpoint)
      })
      .catch((res) => {
        NotificationService.error(res.data.errors[0].message)
      })
      .finally(() => {
        vm.isLoading = false;
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/webhooks/endpoints/endpoints.controller.js